/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/4/20
 * Time: 4:59 PM
 */

import * as actionTypes from "./actionType";
import swal from "sweetalert";
import * as constants from "../../../const/constants";
import {lang, language} from "../../../const/language";

export const setModal = (data) => {
  return {
    type: actionTypes.SET_MODAL,
    value: data
  }
};
export const setPaymentModal = (data,value) => {
    return (dispatch, getState) => {
        let userType = getState().auth.userType;

        if(userType === 1){
            dispatch(setPaymentModal_(data,value))
        }else{
            swal({
                title: constants.GUEST_STUDENT_FOR_PURCHASE,
                icon: null,
                closeOnClickOutside: false,
                buttons: {
                    cancel: language[lang].NotNowText,
                    dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                },
            }).then((value) => {
                switch (value) {
                    case "action":
                        // props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
                        window.location = `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`;
                        dispatch(setPaymentModal_(false,null));
                        break;
                    default:
                        break;
                }
            });
        }
    }

};

export const setPaymentModal_ = (data,value) => {
    return {
        type: actionTypes.SET_PAYMENT_MODAL,
        value: data,
        data: value
    }
};
